export default __webpack_public_path__ + "static/media/(6).1f33bbc9.jpeg";